/* global Config */

// Vendor Libs
import React from 'react';
import {Provider} from 'react-redux';
import {LocationProvider, Router} from '@reach/router';
import {SnackbarProvider} from 'notistack';
import {hot} from 'react-hot-loader/root';

// Styles
import './styles/styles.scss';

// Core
import store, {history} from './redux/store';

// Components
import Client from './components/client';
import ForgotPassword from './components/user/forgot-password';
import Login from './components/user/login';
import Main from './components/layout/main';
import NoMatch from './components/layout/no-match';
import Role from './components/role';
import Users from './components/user';
import ResetPassword from './components/user/reset-password';

const basePath = Config.base.basePath || '/';

const App = () => (
    <Provider store={store}>
        <SnackbarProvider
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            maxSnack={5}
        >
            <LocationProvider history={history}>
                <Router>
                    <Login path={Config.base.loginPath} />
                    <ForgotPassword path={Config.base.forgotPasswordPath} redirectUrl={Config.base.loginPath} />
                    <ResetPassword path={Config.base.resetPasswordPath} redirectUrl={Config.base.loginPath} />
                    <Main path={basePath}>
                        <Client path="client/*" />
                        <Client path={basePath} />
                        <Role path="role/*" />
                        <Users path="user/*" />
                        <Logout path="logout/*" />
                        <NoMatch default={true} />
                    </Main>
                </Router>
            </LocationProvider>
        </SnackbarProvider>
    </Provider>
);

const Logout = () => <h3>Logging out...</h3>;
export default Config.base.env === 'development' ? hot(App) : App;
